import styled from 'styled-components';
import { token } from '@zillow/constellation';

export const HamburgerButton = styled.button.attrs({ className: 'hamburger' })`
    padding: 0 ${token('spacing.sm')}px;
    display: inline-block;
    cursor: pointer;
    border: 0;
    transition-property: opacity, filter;
    transition-duration: 0.15s;
    transition-timing-function: linear;
    background-color: transparent;
    order: 0;
    &:focus {
        outline-offset: -2px;
        outline: 1px dotted ${token('colors.blue400')};
        outline: 5px auto -webkit-focus-ring-color;
    }
    &:-moz-focusring {
        border: 1px dotted ${token('colors.blue400')};
    }
    &::-moz-focus-inner {
        border: 0;
    }
`;
